export default {
  create: {
    method: 'post',
    url: '/quote/quote-request'
  },
  updateStatus: {
    method: 'put',
    url: '/journey/ID/cancel'
  },
  changePartner: {
    method: 'put',
    url: '/journey/ID/change-partner'
  },
  updateContainerNo: {
    method: 'put',
    url: '/journey/ID/container-number'
  }
}
